import { BadgeCheck, ShieldCheck } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa6";
import { Mail } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { WHATSAPP, EMAIL } from "@/data/content";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  const { t } = useLang();

  const links = [
    { id: "platforms", label: t.nav.platforms },
    { id: "features", label: t.nav.features },
    { id: "demographics", label: t.nav.demographics },
    { id: "testimonials", label: t.nav.testimonials },
  ];

  return (
    <footer
      data-testid="footer"
      className="bg-slate-950 text-white pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 font-heading font-black text-xl">
            <BadgeCheck className="h-6 w-6 fill-blue-500 text-white" />
            {t.hero.name}
          </div>
          <p className="mt-3 text-sm text-slate-400 max-w-xs">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <h4 className="font-bold text-sm mb-4 text-slate-200">
            {t.footer.quickLinks}
          </h4>
          <ul className="space-y-2">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollTo(l.id)}
                  className="text-sm text-slate-400 hover:text-cyan-400 transition-colors"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-sm mb-4 text-slate-200">
            {t.footer.contactTitle}
          </h4>
          <div className="space-y-3">
            <a
              data-testid="footer-whatsapp"
              href={`https://wa.me/${WHATSAPP}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors"
            >
              <FaWhatsapp className="h-4 w-4 text-emerald-400" />
              <span dir="ltr">+966 50 688 3553</span>
            </a>
            <a
              data-testid="footer-email"
              href={`mailto:${EMAIL}`}
              className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors"
            >
              <Mail className="h-4 w-4 text-cyan-400" />
              {EMAIL}
            </a>
          </div>
          <div className="mt-6 flex items-start gap-2 rounded-lg border border-slate-800 bg-slate-900/60 p-3">
            <ShieldCheck className="h-5 w-5 text-yellow-500 shrink-0 mt-0.5" />
            <div className="text-xs text-slate-400 leading-relaxed">
              <div className="text-slate-200 font-medium">
                {t.footer.licenseAuthority}
              </div>
              <div>{t.footer.licenseNumber}</div>
              <div>{t.footer.licenseValid}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-12 pt-6 border-t border-slate-800 text-center text-xs text-slate-500">
        {t.footer.rights}
      </div>
    </footer>
  );
};
